const animationManagingFooterEffect = () => {
	const container = document.querySelector('.media-object-container');

	if (container) {
		const content = container.querySelector('.media-content');
		const elements = content.querySelectorAll('.media-content > div > *');
		const image = container.querySelector('.media-image');

		gsap.set(elements, { y: 40, autoAlpha: 0 });

		gsap.from(content, {
			scrollTrigger: {
				trigger: content,
				once: true,
			},
			duration: 0.6,
			left: '-=100%',
			ease: 'power1.out',
			onComplete: () => {
				ScrollTrigger.batch(elements, {
					interval: 0.1,
					onEnter: (batch) =>
						gsap.to(batch, {
							duration: 0.6,
							y: 0,
							autoAlpha: 1,
							ease: 'power2.in',
							stagger: 0.2,
							overwrite: true,
						}),
				});
			}
		});

		gsap.from(image, {
			scrollTrigger: {
				trigger: image,
				start: 'top+=2% bottom',
				once: true,
			},
			duration: 0.5,
			autoAlpha: 0,
			x: 100,
			ease: 'none',
		});

		ScrollTrigger.addEventListener('refreshInit', () =>
			gsap.set(elements, { autoAlpha: 1, y: 0 })
		);
	}
};

export default animationManagingFooterEffect;
